<template>
  <BContainer
    v-if="currentUser"
    class="px-0"
    fluid
  >

    <div class="py-2 w-100 border-bottom font-weight-bold text-muted mb-3">
      Upcoming Events
    </div>

    <BRow
      v-if="loading"
      class="mb-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h6 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="Object.keys(events).length === 0"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="4"
        />
        <p class="h6 py-2">
          <strong>No events found</strong>
        </p>
      </BCol>
    </BRow>

    <BRow
      v-else
      class="gap-y-3"
    >
      <BCol
        v-for="(eventDay, key) in Object.keys(events)"
        :key="key"
        cols="12"
      >
        <UpcomingEvent
          :current-key="key"
          :event-day="eventDay"
          :events="events"
        />
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import UpcomingEvent from './components/UpcomingEvent.vue'

import formatter from '@/mixins/formatter'

export default {
  name: 'FSODashboardUpcomingEvents',

  components: {
    UpcomingEvent
  },

  mixins: [
    formatter
  ],

  props: {
    loading: {
      type: Boolean,
      required: true
    },
    schedule: {
      type: String,
      required: true
    },
    events: {
      type: [Array, Object],
      required: true
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  }
}
</script>
